import React from "react";
import { Divider, Table, Modal, Avatar, Image } from "antd";

import { ToastContainer, toast } from 'react-toastify';
import IntlMessages from "../../../../util/IntlMessages";
import { useGetContactUs } from "src/hooks/services/baseData/useGetContactUs";

const confirm = Modal.confirm;

const List = (props) => {
  const { data: ContactUs, isLoading } = useGetContactUs();


  const columns = [
    {
      title: "ایمیل",
      dataIndex: "email",
      key: "email",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "نام و نام خانوادگی",
      dataIndex: "fullName",
      key: "fullName",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "پیام",
      dataIndex: "message",
      key: "message",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "تاریخ",
      dataIndex: "dateTime",
      key: "dateTime",
      render: (text) => <span>
        {text && text.split("T")[0]}
      </span>
    }
  ];

  return (
    <>
      <Table
        className="gx-table-responsive"
        columns={columns}
        dataSource={ContactUs}
        rowKey="contactUsId"
        pagination={false}
      />
    </>
  );
};

export default List;
